import React from 'react'

export const PHYSICIAN_OR_PROVIDER = 'PHYSICIAN_OR_PROVIDER'
export const HOSPITALS = 'HOSPITALS'
export const SCAN_FACILITIES = 'SCAN_FACILITIES'
export const BIOPSY_FACILITIES = 'BIOPSY_FACILITIES'
export const OTHER_FACILITIES = 'OTHER_FACILITIES'